module.exports = __webpack_public_path__ + "static/media/CeraPro-Italic.f15e99a2.eot";